import CONSTANTS from "./Constants";
import EventEmitter from "events";
import { checkBrowser, hasTouch, throttle } from "./Utils"

export default class SafeMargin extends EventEmitter{

    constructor (spread) {
        super();
        this.spread = spread;
    }

    bind(){
        if(!this.bound){
            this.bound = true;
            $(window).on(`resize.${this.spread.spread_id}`, throttle(this.onWindowResizeEvent.bind(this), 200));
        }
    }

    unbind (){
        $(window).off(`resize.${this.spread.spread_id}`);
        this.bound = false;
    }

    onWindowResizeEvent (event, data) {
        // this.emit(CONSTANTS.EVENTS.BEFORE_RESIZE);
        this.spread.clearSizes();
        //check if there is a video playing. if so prevent resizing.
        if(this.spread.currentScene && this.spread.currentScene.videos){
            let maglrFullscreenElement = false;
            if(checkBrowser() === CONSTANTS.VENDORS.SAFARI){
                maglrFullscreenElement = this.spread.getSpreadElement(true).find('video').get().some(el => el.webkitDisplayingFullscreen)
            }

            const fullscreen_el = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || maglrFullscreenElement;
            if( this.spread.active_layout === 2 && fullscreen_el ){
                console.warn("Dont resize, there is a fullscreen video player active while in mobile mode", fullscreen_el);
                this.spread.getSpreadElement(true).addClass("fullscreen_active");
                return false;
            }

            if( this.spread.getSpreadElement(true).hasClass("fullscreen_active") ){
                console.log("has fullscreen active, remove the class because that is not true anymore");
                this.spread.getSpreadElement(true).removeClass("fullscreen_active");
                return false;
            }
        }

        const checkResult = this.doScreenSizeChecks()
        if (checkResult.changed) {
            if (checkResult.mobile) {
                this.spread.active_layout = 2;
            } else {
                this.spread.active_layout = 1;
            }

            this.emit(CONSTANTS.EVENTS.LAYOUT_CHANGED);
            return false;
        }

        if (this.didWindowSizeChange() || (data && data.force)) {
            this.emit(CONSTANTS.EVENTS.WINDOW_SIZE_CHANGED);

            if (this.spread.active_layout === 2) {
                this.calculateMobileZoom();
            } else {
                const scenes = this.spread.runSelector(".layout.desktop .scene")
                let currentScene = scenes.filter(".current_scene")
                if (currentScene.length === 0) {
                    currentScene = scenes.first()
                }

                if (this.spread.status >= CONSTANTS.STATUS.SHOWN) {
                    this.checkOrientation(currentScene);
                }

                scenes.each((i, el) => {
                    const scene = $(el)
                    let size_data
                    switch (scene.data("pagetype")){
                        case CONSTANTS.PAGETYPES.FULLSCREEN:
                            size_data = this.calculateSafeMarginFullscreen(scene);
                            break;
                        case CONSTANTS.PAGETYPES.STATICSIZE:
                            size_data = this.calculateSafeMarginStaticSize(scene);
                            break;
                        case CONSTANTS.PAGETYPES.ZOOM:
                            size_data = this.calculateSafeMarginZoom(scene);
                            break;
                        case CONSTANTS.PAGETYPES.LONGPAGE:
                            size_data = this.calculateSafeMarginLongpage(scene);
                            break;
                    }
                    this.spread.setSceneSizeData(scene.attr('id'), size_data);
                })
            }
        }
        this.triggerAfterResize();
    }


    didWindowSizeChange(){
        // use window width & height here because we need to know if the window size changed. So dont use cached sizes.
        const width = document.documentElement.clientWidth
        const height = window.innerHeight
        let result = (width !== this.previousWidth || height !== this.previousHeight || this.previousStatus !== this.spread.status)

        if(result && this.spread.scrollingBody && hasTouch() && this.spread.isScrolled() ){
            result = (Math.abs(width - this.previousWidth) > 75 || Math.abs(height - this.previousHeight) > 75 || this.previousStatus !== this.spread.status);
        }
        if(result){
            this.previousWidth = width;
            this.previousHeight = height;
            this.previousStatus = this.spread.status;
        }

        return result && (!this.spread.pageTransitions || (this.spread.pageTransitions && !this.spread.pageTransitions.isAnimating));
    }

    doScreenSizeChecks(){
        let was_mobile = this.spread.active_layout === 2;
        let mobile = !this.spread.noMobile && this.spread.getSpreadElement(false).offsetWidth < 501
        return {
            changed: mobile !== was_mobile,
            mobile: mobile
        };
    }

    triggerAfterResize(){
        this.emit(CONSTANTS.EVENTS.RESIZE_DONE);
    }

    checkOrientation(scene){
        if (!this.overlay) {
            this.overlay = this.spread.runSelector(".layout.desktop .overlay")
        }

        if (scene.data("pagetype") === "longpage" || this.spread.injected || this.spread.embedded) {
            this.overlay.hide()
        } else {

            const dimensions = scene.data("dimensions")
            const original_o = (dimensions.width/dimensions.height) >= 1
            const window_o = (this.previousWidth / this.previousHeight) >= 1

            if (original_o !== window_o){
                this.overlay.show()
            }else{
                this.overlay.hide()
            }
        }
    }

    calculateSafeMarginFullscreen(scene){
        const dimensions = scene.data('dimensions')
        const upscale = scene.data('upscale')
        const windowWidth = this.spread.getWindowWidth()
        const windowHeight = this._getEmbeddedSceneHeight(scene, windowWidth) || this.spread.getWindowHeight()

        const v_scale = windowHeight / dimensions.safemarginHeight; // vertical scale
        const h_scale = windowWidth / dimensions.safemarginWidth; // horizontal scale
        const scale = Math.min(v_scale, h_scale, upscale ? Infinity : 1);

        this.setScaleCssVar(scene[0], scale)

        return {
            height: windowHeight,
            scale,
        };
    }

    calculateSafeMarginStaticSize(scene){
        const windowWidth = this.spread.getWindowWidth()
        const windowHeight = this._getEmbeddedSceneHeight(scene, windowWidth) || this.spread.getWindowHeight()
        const dimensions = scene.data('dimensions')

        const h_scale = windowWidth / dimensions.safemarginWidth;
        const v_scale = windowHeight / dimensions.safemarginHeight;
        const scale = Math.min(v_scale, h_scale, 1);

        this.setScaleCssVar(scene[0], scale)

        return {
            height: windowHeight,
            scale: scale,
        };
    }

    calculateSafeMarginLongpage(scene){
        const dimensions = scene.data('dimensions')
        const upscale = scene.data('upscale')
        const windowWidth = this.spread.getWindowWidth()

        const sceneFits = dimensions.width <= windowWidth
        const safemarginFits = dimensions.safemarginWidth <= windowWidth

        let scale;
        if (sceneFits) {
            scale = windowWidth/dimensions.width;
        } else {
            scale = windowWidth/dimensions.safemarginWidth;
        }

        if (!upscale || (safemarginFits && !sceneFits)) {
            scale = Math.min(scale, 1); // This prevents longpage upscale
        }

        this.setScaleCssVar(scene[0], scale)
        return {
            height: dimensions.height * scale,
            scale,
        };
    }

    calculateSafeMarginZoom(scene){
        const dimensions = scene.data('dimensions')
        const windowWidth = this.spread.getWindowWidth()
        const windowHeight = this._getEmbeddedSceneHeight(scene, windowWidth) || this.spread.getWindowHeight()
        const scale = Math.min(windowHeight/dimensions.safemarginHeight, windowWidth/dimensions.safemarginWidth)

        this.setScaleCssVar(scene[0], scale)

        return {
            height: windowHeight,
            scale,
        }
    }

    calculateMobileZoom(){
        const windowWidth = this.spread.getWindowWidth()
        const scale = windowWidth / 375

        this.spread.scenes.forEach((scene) => {
            let jq_scene_element = scene.getSceneElement(true),
                height = parseInt(jq_scene_element[0].dataset.height)
            ;
            scene.setSceneSizeData({
                height: height * scale,
                scale: scale,
            });

            this.setScaleCssVar(jq_scene_element[0], scale)
        });
    }

    _getEmbeddedSceneHeight(scene, windowWidth){
        //if not embedded with control OR not in fullheight return false
        if (!this.spread.injected && !this.spread.embedded) {
            return false;
        }
        // if in singlepage mode always use windowHeight
        if (!this.spread.embedded && this.spread.options.injected && this.spread.options.injected.singlePage) {
            return false
        }

        const data = scene.data();
        const dimensions = scene.data('dimensions')
        if(data.pagetype === CONSTANTS.PAGETYPES.ZOOM || data.pagetype === CONSTANTS.PAGETYPES.FULLSCREEN){
            if(this.spread.embeddedType === CONSTANTS.EMBEDTYPES.STATIC){ // static embed will always be as high as it can
                return false;
            }


            if(this.spread.embeddedType === CONSTANTS.EMBEDTYPES.FULLHEIGHT && this.spread.embeddedSizeSetting === 'height'){
                return parseInt(dimensions.height) * Math.min(windowWidth / parseInt(dimensions.width), 1)
            }


            if( this.spread.embeddedSizeSetting === 'height'){
                return dimensions.height// Voor embed Max height
            }else{
                const ratio = dimensions.width / dimensions.height
                return Math.min(Math.round(windowWidth / ratio), this.spread.getWindowHeight());
            }
        }else{
            return dimensions.height //Voor embed Max height
        }
    }

    setScaleCssVar(element, scale){
        element.style.setProperty('--sceneScale', scale);
    }
}

